import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {paidAsRankDescLastMonth} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {
  frontLineCoachMetrics,
  gen0CoachMetrics,
  totalGenerationVolumeMetrics,
} from '/redux/selector/metric.home.selector';
import {withProps} from '/util/selector.util';

import DashboardMetricCards from './DashboardMetricCards';

const withCurrentUserCoachId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    frontLineCoachMetrics: withCurrentUserCoachId(frontLineCoachMetrics),
    gen0CoachMetrics: withCurrentUserCoachId(gen0CoachMetrics),
    totalGenerationVolumeMetrics: withCurrentUserCoachId(
      totalGenerationVolumeMetrics,
    ),
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
  }),
)(DashboardMetricCards);
